import api from '../baseApi.js'
import { unwrap } from '../helpers.js'

export const timetableApi = {
  getByClass: (classId) => api.get(`/timetable/class/${classId}`).then(unwrap),
  getByTeacher: (teacherId) => api.get(`/timetable/teacher/${teacherId}`).then(unwrap),
  getTeacherAvailability: (params) =>
    api.get('/timetable/availability/teachers', { params }).then((response) => (
      Array.isArray(response?.data?.data)
        ? response.data.data
        : Array.isArray(response?.data)
        ? response.data
        : []
    )),
  save: (data) => api.post('/timetable', data).then(unwrap),
  remove: (classId) => api.delete(`/timetable/class/${classId}`).then(unwrap),
}
